import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/athlete-proposition-bet.module.scss";
import {TOOLTIP_PLACEMENT} from "../../../core/components/tooltip/tooltip-consts";
import {OddsTooltip} from "../../../core/components/odds/tooltip/odds-tooltip";
import {PropositionBetsWidgetRowOptionName} from "../../../widgets/proposition-bets-widget/components/row/option/proposition-bets-widget.row.option.name";
import {PropositionBetsWidgetRowOptionRate} from "../../../widgets/proposition-bets-widget/components/row/option/proposition-bets-widget.row.option-rate";
import {GAME_STATUSES} from "../../../core/app/consts";
import {Link} from "../../../core/components/link/link";
import {LINK_REL} from "../../../core/consts";

export const AthletePropositionBetModuleOption = observer(({controller, row, option, onBookieClick, bookieHrefModel}) => {
  const {state} = controller;
  const {bookmaker, sportTypeId, game} = state;

  const betsImpressionParams = {
    bookieId: bookmaker?.id,
    bookieName: bookmaker?.name,
    sportTypeId
  }

  const tooltipProps = {
    option,
    bookmaker,
    onClick: () => onBookieClick(),
    bookieHrefModel,
    placement: TOOLTIP_PLACEMENT.bottom,
    showOriginalOdds: game.statusGroup !== GAME_STATUSES.ended,
    betsImpressionParams,
    controller
  };

  const containerProps = {
    model: bookieHrefModel,
    rel: LINK_REL.SPONSORED_NOOPENER,
    className: classNames(styles.option, {[styles.win_option]: option?.isWon}),
    onClick: (e) => {
      e.stopPropagation();

      return onBookieClick()
    }
  }

  const nameProps = {
    row,
    option
  }

  const rateProps = {
    className: classNames(styles.option_rate),
    controller,
    betsImpressionParams,
    option
  }

  return (
    <OddsTooltip {...tooltipProps}>
      <Link {...containerProps}>
        <PropositionBetsWidgetRowOptionName {...nameProps}/>
        <PropositionBetsWidgetRowOptionRate {...rateProps}/>
      </Link>
    </OddsTooltip>
  )
});

